import { t } from 'i18next';
import * as yup from 'yup';

export const assignUomSchema = () =>
  yup.object().shape({
    uom: yup.string().label(t('changeUomTo')).nullable().required(),
  });
